module.exports = __webpack_public_path__ + "img/compare-1.630d57e2.jpg";